<template>
  <div id="events-top">
    <transition-group name="fade">
      <ArticleItem
        v-for="article in articles"
        :key="article.id"
        :article="article"
        v-show="loaded"
      />
    </transition-group>
    <BasePagination
      :current-page="currentPage"
      :page-count="pageCount"
      class="articles-list__pagination"
      @nextPage="pageChangeHandle('next');"
      @previousPage="pageChangeHandle('previous');"
      @loadPage="pageChangeHandle"
      v-if="pageCount>=2"
    />
    <div v-if="!articles.length" class="pt-5">No events match that filter.</div>
      <!-- <img :src="this.axios.defaults.baseURL+'/wp-content/uploads/2020/06/arrow-right.svg'" alt="previous" style="transform: scaleX(-1);" aria-hidden="true"> -->

  </div>
</template>

<script>
import axios from "axios";
import ArticleItem from "./ArticleItem";
import BasePagination from "./BasePagination.vue";

export default {
  name: "ArticlesList",
  static: {
    visibleItemsPerPageCount: 5 // custom
  },
  props: ['category', 'month'],
  data() {
    return {
      articles: [],
      currentPage: 1,
      pageCount: 0,
      categoryEndPoint: '',
      dateEndPoint: '',
      loaded: true
    };
  },

  components: {
    ArticleItem,
    BasePagination
  },

  async mounted() {
    try {
      // console.log(this.categoryFilter);
      // let categoryEndPoint = '';
      
      if(this.category){
        // console.log('is this.category set in child component: '+this.category);
        this.categoryEndPoint = '&slug='+this.category;
      }
      if(this.month){
        // this.month.format('YYYY-MM');
        // console.log('is this.month set in child component: '+this.month.format('YYYY-MM'));
        this.dateEndPoint = '&event_year_month='+this.month.format('YYYY-MM');
      }

      return axios.get(
        `/wp-json/pcc-api/v1/events?page=1&per_page=${
          this.$options.static.visibleItemsPerPageCount + this.categoryEndPoint + this.dateEndPoint
        }`
      ).then((response) => {
        // console.log(response.data);
        // console.log('response.status');
        // console.log(response.status);
        // console.log(response.statusText);
        // console.log(response.headers);
        // console.log(totalHeaders);
        // console.log(response.config);
        this.pageCount = Number(response.headers['x-wp-totalpages']);
        // console.log(response.data);
        this.articles = response.data;
      }).catch(error => {
          console.log("Error Response: ", error.response)
          // console.log("error status", error.response.status);
      });
      // const { data } = await axios.get(
      //   `?country=us&page=1&pageSize=${
      //     this.$options.static.visibleItemsPerPageCount
      //   }&category=business&apiKey=065703927c66462286554ada16a686a1`
      // );
      // this.articles = data;      
      // this.articles = data.articles;
      // this.pageCount = Math.ceil(
          // 70 / 4 = 17.5
      //   data.totalResults / this.$options.static.visibleItemsPerPageCount        
      // );
      
    } catch (error) {
      // throw error;
      console.log(error);
    }
  },
  methods: {
    async pageChangeHandle(value) {
      this.loaded = false;
      try {
      switch (value) {
        case "next":
          this.currentPage += 1;
          break;
        case "previous":
          this.currentPage -= 1;
          break;
        default:
          this.currentPage = value;
          break;
      }
      // const { data } = await axios.get(
      //   `?country=us&page=${this.currentPage}&pageSize=${
      //     this.$options.static.visibleItemsPerPageCount
      //   }&category=business&apiKey=065703927c66462286554ada16a686a1`
      // );
      // console.log(this.category);
      if(this.month){
        // console.log('this.month');
        // console.log(this.month);
      }
      // let categoryEndPoint = '';
      // if(this.category){
      //   console.log('is this.category set in child component'+this.category);
      //   categoryEndPoint = '&slug='+this.category;
      // }
      
      const { data } = await axios.get(
        `/wp-json/pcc-api/v1/events?page=${this.currentPage}&per_page=${
          this.$options.static.visibleItemsPerPageCount + this.categoryEndPoint + this.dateEndPoint
        }`
      );
      this.articles = data;
      this.loaded = true;
      } catch(error) {
        console.log("Error Response: ", error);
        // appropriately handle the error
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
// .articles-list {
//   &__pagination {
//     position: fixed;
//     bottom: 50px;
//     position: absolute;
//     bottom: -67px;
//     left: 50%;
//     transform: translateX(-50%);
//   }
// }
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease-out .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
